import { DEFAULT_PAGE_SIZE } from '../../config'
import ApiClient from '../apiClient'
import { getUserId } from '../user'

const client = new ApiClient()

const getFinancialStatements = ({
  userId = getUserId(),
  page = 1,
  per_page = DEFAULT_PAGE_SIZE,
}) => {
  return client.get(`/users/${userId}/financial-statements`, {
    params: { page, per_page },
  })
}

const financialStatementService = {
  getFinancialStatements,
}

export default financialStatementService
